'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosFiling = function IoIosFiling(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm19.8 22.5c2.3 0 4.2-1.6 4.8-3.7h8.9v11.2h-27.5v-11.2h8.9c0.6 2.1 2.5 3.7 4.9 3.7z m-8.8-5h-5l5-7.5v6.3h1.3v-6.3h15v6.3h1.2v-6.3l5 7.5h-10c0 2-1.7 3.8-3.7 3.8s-3.8-1.8-3.8-3.8h-5z' })
        )
    );
};

exports.default = IoIosFiling;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-filing.js
// module id = 2182
// module chunks = 0